export interface RequestStatusState {
    requestsByType: Map<RequestStatusType, RequestStatusForType>;
}

export enum RequestStatusType {
	LoadJob,
	CompleteJob,
	UpdateJobChannelSettings,
	LoadEngagement
}

export interface RequestStatusForType {
	requestsById: Map<RequestStatusId, 'pending'>;
}

export type RequestStatusId = string | number;